import { createSlice } from '../../../canvas/core';
import type { PageId } from '../../core';
import * as updaters from './state-updaters';
import type {
  CanvasRendererFn,
  PageCanvasOverlayDeps,
  PageCanvasOverlaySlice,
} from './types';

export const createPageCanvasOverlaySlice =
  createSlice<PageCanvasOverlayDeps>()<PageCanvasOverlaySlice>(set => ({
    pageCanvasOverlay: {
      state: {
        renderers: {},
      },
      actions: {
        registerRenderer: (
          pageId: PageId,
          id: string,
          render: CanvasRendererFn
        ) => set(updaters.registerRenderer(pageId, id, render)),
        unregisterRenderer: (pageId: PageId, id: string) =>
          set(updaters.unregisterRenderer(pageId, id)),
      },
    },
  }));
